// extracted by mini-css-extract-plugin
export var box = "product-module--box--a5b19";
export var buzzwordContainer = "product-module--buzzwordContainer--270c2";
export var content = "product-module--content--24835";
export var description = "product-module--description--c4e3a";
export var flexbox = "product-module--flexbox--7deea";
export var gatsbyRespImageBackgroundImage = "product-module--gatsby-resp-image-background-image--05954";
export var gatsbyRespImageLink = "product-module--gatsby-resp-image-link--32c8c";
export var headerContainer = "product-module--headerContainer--9c4b6";
export var headerContent = "product-module--headerContent--21f43";
export var headerImage = "product-module--headerImage--e2d7d";
export var imageHolder = "product-module--imageHolder--05fed";
export var input = "product-module--input--d532d";
export var list = "product-module--list--4e1a0";
export var load8 = "product-module--load8--9960c";
export var loader = "product-module--loader--fb52b";
export var orange = "product-module--orange--848a2";
export var petrol = "product-module--petrol--f7f63";
export var petrolToOrange = "product-module--petrol-to-orange--e66d0";
export var purple = "product-module--purple--a342d";
export var purpleToOrange = "product-module--purple-to-orange--80803";
export var servicesContainer = "product-module--servicesContainer--ec77f";
export var servicesHolder = "product-module--servicesHolder--52499";
export var smallImage = "product-module--smallImage--c27e1";